#import "./SageGiftAccountDifferenceFields.graphql"

mutation AcceptSageGiftAccountDifferences($ids: [ID!]!) {
  acceptSageGiftAccountDifferences(input: { ids: $ids }) {
    results {
      id
      success
      error
      difference {
        ...SageGiftAccountDifferenceFields
      }
    }
  }
}
